import { ChangeDetectionStrategy, Component, computed, effect, input, signal, ViewEncapsulation } from '@angular/core';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';
import { Table } from '@common/data-models/complex-types/table';

@Component({
    selector: 'st-special',
    templateUrl: './special.html',
    styleUrls: ['./special.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-special',
    },
})
export class SpecialComponent extends EnpsControlComponent<Table> {
    // TODO MAKE A TYPE FOR THIS PLEASE
    columns = input<any[]>();

    internalValue = signal<Table>(null);

    model = computed(() => {
        return this.internalValue()?.data || [];
    });

    constructor() {
        super();
        effect(
            () => {
                const val = this.value() || new Table();
                if (!val?.colMetadata?.length) {
                    val.colMetadata = this.columns();
                    val.addEmptyRowIfNeeded();
                }
                this.internalValue.set(val);
            },
            { allowSignalWrites: true }
        );
    }

    getValue(row: number, col: number): any {
        return this.internalValue()?.get(row, col) || '';
    }

    valueChanged(value: string | number, row: number, col: number) {
        this.internalValue.update(val => {
            val.set(row, col, value);
            return val;
        });
        this.changed.emit(this.internalValue());
    }
}
